import { registerApplication, start } from 'single-spa'
import {
    constructApplications,
    constructRoutes,
    constructLayoutEngine,
} from 'single-spa-layout'
import { apm as apmDP } from '@Techedge/digitalportal-shared'

// import { init as initApm } from '@elastic/apm-rum'

const apm = apmDP
// const apm = initApm({
//     serviceName: 'digital-portal-root-mfe', // Set APM Server URL

//     serverUrl: process.env.APM_SERVER_URL, // Set the service version (required for source map feature)

//     serviceVersion: '1.0', // Set the service environment

//     environment: process.env.REACT_APP_ENV,
//     // logLevel: 'debug',
//     disableInstrumentations: JSON.parse(
//         process.env.APM_DISABLE_INSTRUMENTATIONS
//     ),
//     //   distributedTracing: true,
//     //   distributedTracingOrigins: [BACKEND_ENDPOINT],
//     flushInterval: 500,
// })

import packageJson from '../package.json'
console.log(
    '%c' +
        packageJson.name +
        ' v' +
        packageJson.version +
        ' - ENVIRONMENT: ' +
        process.env.REACT_APP_ENV +
        ' - BUILD_TYPE: ' +
        process.env.NODE_ENV,
    'background: purple; color: white; font-size:12px; padding: 5px;'
)

if (process.env.REACT_APP_ENV === 'development') {
    localStorage.setItem('devtools', 'true')
}

const routes = constructRoutes(
    document.querySelector('#single-spa-layout') as HTMLTemplateElement
)

const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name)
    },
})

const layoutEngine = constructLayoutEngine({ routes, applications })

applications.forEach(registerApplication)
layoutEngine.activate()

start()

let loggedIn = false

//TODO: GESTIONE DEL REDIRECT VERTICALIZZATA PER LA FRUIZIONE DEL PICTURE MGMT - DA RIVEDERE

const eventCallback = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const accessTokenParam = urlParams.get('jwt')

    if (window.location.pathname === '/') {
        if (
            localStorage.getItem('ROOT_ACCESS_TOKEN') &&
            localStorage.getItem('ROOT_ACCESS_TOKEN') !== 'undefined'
        ) {
            // window.location.replace("../picture-mgmt");
        } else {
            if (!accessTokenParam) {
                window.location.href = process.env.NETIQ_REDIRECT_URL
            }
        }
    } else if (window.location.pathname === '/auth') {
        window.location.href = process.env.NETIQ_REDIRECT_URL
    } else if (
        window.location.pathname.includes('/login_error') ||
        window.location.pathname === '/ntm'
    ) {
        return
    } else if (window.location.pathname === '/logout') {
        // localStorage.clear()
        if (process.env.REACT_APP_ENV === 'development') {
            localStorage.setItem('devtools', 'true')
        }
    } else {
        setTimeout(() => {
            if (
                (window.location.pathname !== '/logout' &&
                    !localStorage.getItem('ROOT_ACCESS_TOKEN')) ||
                localStorage.getItem('ROOT_ACCESS_TOKEN') === 'undefined'
            ) {
                window.location.href = process.env.NETIQ_REDIRECT_URL
            }
        }, 500)
    }
    loggedIn = true
    // if (
    //     accessTokenParam &&
    //     localStorage.getItem('ROOT_ACCESS_TOKEN') &&
    //     localStorage.getItem('ROOT_ACCESS_TOKEN') !== 'undefined'
    // )
    //     window.location.href = window.location.origin
}

window.addEventListener('single-spa:routing-event', eventCallback, true)

/*
window.addEventListener(
    'PICMGMT_MICROFRONTEND_LOADED',
    () => {
        document.getElementById('picmgmt_loader').style.display = 'none'
    },
    true
)

window.addEventListener(
    'PICMGMT_MICROFRONTEND_LOADING',
    () => {
        document.getElementById('picmgmt_loader').style.display = 'flex'
    },
    true
)
*/

// window.addEventListener(
//   UserHelperEvents.LOGOUT.toString(),
//   () => {
//     // window.location.href = process.env.NETIQ_REDIRECT_URL
//   },
//   true
// );

// window.addEventListener(
//   UserHelperEvents.LOGOUT_ERROR.toString(),
//   () => {
//     // window.location.href = process.env.NETIQ_REDIRECT_URL
//     window.location.href = "../logout-error";
//     // document.getElementById('picmgmt_loader').style.display = 'none'
//   },
//   true
// );

export default apm
